import _toConsumableArray from "/root/code/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _taggedTemplateLiteral from "/root/code/node_modules/next/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: -2px;\n  width: ", "px;\n  cursor: pointer;\n  background-color: ", ";\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);\n  z-index: 101;\n  transition: max-height 0.5s cubic-bezier(0.22, 0.61, 0.36, 1) 0s;\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    width: 168px;\n    height: 16px;\n    top: -16px;\n    background-color: inherit;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  font-size: ", ";\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0px 10px;\n  margin-right: 57px;\n  ", "\n\n  @media (min-width: ", ") {\n    &:hover {\n      background-color: white;\n      ", "\n    }\n    ", "\n  }\n\n  @media (max-width: ", ") and (min-width: ", ") {\n    padding: 6px 16px;\n    border-radius: 100px;\n    border: 1px solid;\n    border-color: ", ";\n    margin-left: 24px;\n    margin-right: 4px;\n    height: auto;\n\n    &:active {\n      box-shadow: inset 0px 4px 4px ", ";\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  @media (max-width: ", ") and (min-width: ", ") {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n    overflow-x: auto;\n    overflow-y: hidden;\n    white-space: nowrap;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState, useCallback } from "react";
import { Box, Flex, IconDownArrow, IconHamburger, Span, styled, themeGet, minusOnePx, Popover, PopoverControl } from "@catchoftheday/cg-components";
import { useIsTabletView } from "@header-app/hooks/useIsTabletView";
import { trackMenuImpression } from "../../utilities/analytics";
import { CATEGORY_MENU_DESKTOP_WIDTH, POPOVER_ZINDEX } from "../consts";
import { MenuItem } from "../MenuItem";
import { SlideInMenu } from "../SlideInMenu";
import { CategoryMenu } from "../CategoryMenu";
import { getNavData } from "./utilities";
import { jsx as ___EmotionJSX } from "@emotion/react";
var BOX_SHADOW_STYLE = "box-shadow: 0px -5px 10px #bfbfbf;";
var MenuContainer = styled(Box)(_templateObject(), function (props) {
  return minusOnePx(themeGet("breakpoints.lg")(props));
}, themeGet("breakpoints.md"));
var ShopAllCategoriesButton = styled(Flex)(_templateObject2(), themeGet("fontSizes.sm"), function (props) {
  return props.isSubmenuOpen && BOX_SHADOW_STYLE;
}, function (props) {
  return themeGet("breakpoints.lg")(props);
}, BOX_SHADOW_STYLE, function (props) {
  return props.isSubmenuOpen && "background-color: white;";
}, function (props) {
  return minusOnePx(themeGet("breakpoints.lg")(props));
}, function (props) {
  return themeGet("breakpoints.md")(props);
}, function (props) {
  return themeGet("colors.grey")(props);
}, function (props) {
  return themeGet("colors.grey")(props);
});

var ShopAllCategoriesChildren = function ShopAllCategoriesChildren() {
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(IconHamburger, {
    display: {
      md: "block",
      lg: "none"
    },
    width: "18px",
    height: "auto",
    mr: "10px"
  }), ___EmotionJSX(Span, {
    mr: "12px",
    lineHeight: "1",
    fontWeight: {
      md: "normal",
      lg: "light"
    }
  }, "Shop All Categories"), ___EmotionJSX(IconDownArrow, {
    display: {
      md: "none",
      lg: "block"
    },
    width: "8px",
    height: "auto"
  }));
};

var CategoryMenuContainer = styled(Flex)(_templateObject3(), CATEGORY_MENU_DESKTOP_WIDTH, function (props) {
  return themeGet("colors.ui.backgroundColorSecondary")(props);
});
export var MenuBar = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var shops = _ref.shops,
      checkScrollPosition = _ref.checkScrollPosition,
      recordScrollPosition = _ref.recordScrollPosition;
  var isTabletView = useIsTabletView();

  var _useState = useState(),
      touchedItem = _useState[0],
      setTouchedItem = _useState[1];

  var _getNavData = getNavData(shops),
      primaryNav = _getNavData.primaryNav,
      seasonalNav = _getNavData.seasonalNav;

  var _useState2 = useState(false),
      isMenuOpen = _useState2[0],
      setIsMenuOpen = _useState2[1];

  var _useState3 = useState(0),
      focusItemIndex = _useState3[0],
      setFocusItemIndex = _useState3[1];

  var _useState4 = useState(0),
      categoryMenuContainerMaxHeight = _useState4[0],
      setCategoryMenuContainerMaxHeight = _useState4[1];

  var showMenu = function showMenu() {
    return setIsMenuOpen(true);
  };

  var hideMenu = function hideMenu() {
    return setIsMenuOpen(false);
  };

  var showAllButtons = function showAllButtons(_ref2) {
    var ref = _ref2.ref,
        isOpen = _ref2.isOpen,
        handleOnKeyDown = _ref2.handleOnKeyDown,
        handleOnBlur = _ref2.handleOnBlur,
        handleOnMouseEnter = _ref2.handleOnMouseEnter,
        handleOnMouseLeave = _ref2.handleOnMouseLeave;

    var keyDownHandler = function keyDownHandler(e) {
      if (e.code === "ArrowDown" || e.code === "Enter" || e.code === "Space" || e.code === "Escape") {
        e.preventDefault();

        if (e.code !== "Escape") {
          trackShopAllCategoriesButtonImpression();
        }

        setTimeout(function () {
          var _document$getElementB;

          return (_document$getElementB = document.getElementById("category-menu-item-0")) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.focus();
        }, 100);
        handleOnKeyDown(e);
      }
    };

    return ___EmotionJSX(ShopAllCategoriesButton, {
      id: "menu-bar-item-0",
      role: "button",
      "aria-label": "Open category menu",
      tabIndex: focusItemIndex == 0 ? 0 : -1,
      "aria-expanded": true,
      ref: ref,
      isSubmenuOpen: isOpen,
      onKeyDown: keyDownHandler,
      onBlur: handleOnBlur,
      onMouseEnter: function onMouseEnter() {
        handleOnMouseEnter();
        trackShopAllCategoriesButtonImpression();
      },
      onMouseLeave: handleOnMouseLeave
    }, ___EmotionJSX(ShopAllCategoriesChildren, null));
  };

  var trackShopAllCategoriesButtonImpression = useCallback(function () {
    trackMenuImpression({
      name: "Shop All Categories",
      item_path: [{
        name: "Shop All Categories",
        id: 0,
        position: 0
      }]
    });
  }, []);
  var setShowAllFocus = useCallback(function () {
    var _document$getElementB2;

    (_document$getElementB2 = document.getElementById("menu-bar-item-0")) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.focus();
  }, []);
  var keyDownHandler = useCallback(function (e) {
    var _document$getElementB5, _document$getElementB6, _document$getElementB7;

    switch (e.code) {
      case "ArrowLeft":
        e.preventDefault();

        if (focusItemIndex !== 0) {
          var _document$getElementB3;

          (_document$getElementB3 = document.getElementById("menu-bar-item-".concat(focusItemIndex - 1))) === null || _document$getElementB3 === void 0 ? void 0 : _document$getElementB3.focus();
          setFocusItemIndex(focusItemIndex - 1);
        }

        break;

      case "ArrowRight":
        e.preventDefault();

        if (focusItemIndex !== seasonalNav.length) {
          var _document$getElementB4;

          (_document$getElementB4 = document.getElementById("menu-bar-item-".concat(focusItemIndex + 1))) === null || _document$getElementB4 === void 0 ? void 0 : _document$getElementB4.focus();
          setFocusItemIndex(focusItemIndex + 1);
        }

        break;

      case "Home":
        e.preventDefault();
        (_document$getElementB5 = document.getElementById("menu-bar-item-0")) === null || _document$getElementB5 === void 0 ? void 0 : _document$getElementB5.focus();
        setFocusItemIndex(0);
        break;

      case "End":
        e.preventDefault();
        (_document$getElementB6 = document.getElementById("menu-bar-item-".concat(seasonalNav.length))) === null || _document$getElementB6 === void 0 ? void 0 : _document$getElementB6.focus();
        setFocusItemIndex(seasonalNav.length);
        break;

      case "Space":
        e.preventDefault();
        (_document$getElementB7 = document.getElementById("menu-bar-item-".concat(focusItemIndex))) === null || _document$getElementB7 === void 0 ? void 0 : _document$getElementB7.click();
        break;

      default:
        break;
    }
  }, [seasonalNav.length, focusItemIndex]);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(MenuContainer, {
    role: "menubar",
    "aria-label": "Desktop navigation",
    as: "nav",
    display: "flex",
    height: "50px",
    color: "text",
    position: "relative",
    overflow: "visible",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "center",
    onKeyDown: keyDownHandler,
    onScroll: function onScroll(e) {
      return checkScrollPosition(e.currentTarget);
    },
    ref: ref
  }, isTabletView ? ___EmotionJSX(ShopAllCategoriesButton, {
    role: "button",
    "aria-label": "Open category menu",
    tabIndex: 0,
    "aria-expanded": isMenuOpen,
    onClick: function onClick() {
      showMenu();
      trackShopAllCategoriesButtonImpression();
    }
  }, ___EmotionJSX(ShopAllCategoriesChildren, null)) : ___EmotionJSX(Popover, {
    height: {
      xs: "auto",
      lg: "100%"
    },
    placement: "bottom",
    fullWidth: true,
    hideOnLeave: true,
    hideOnLeaveInterval: 100,
    hideArrow: true,
    zIndex: POPOVER_ZINDEX,
    enhancedKeyboardNavigation: true,
    modifier: {
      flip: {
        enabled: false
      }
    }
  }, ___EmotionJSX(PopoverControl, null, showAllButtons), ___EmotionJSX(CategoryMenuContainer, {
    "aria-label": "Category Menu",
    maxHeight: categoryMenuContainerMaxHeight
  }, ___EmotionJSX(CategoryMenu, {
    shops: primaryNav,
    setCategoryMenuContainerMaxHeight: setCategoryMenuContainerMaxHeight,
    setParentFocus: setShowAllFocus
  }))), ___EmotionJSX(Flex, {
    height: "100%",
    flex: "1",
    overflow: {
      md: "visible",
      lg: "hidden"
    },
    flexWrap: {
      md: "nowrap",
      lg: "wrap"
    }
  }, [null].concat(_toConsumableArray(seasonalNav)).map(function (shop, index) {
    return shop && ___EmotionJSX(MenuItem, {
      index: index,
      tabIndex: focusItemIndex == index ? 0 : -1,
      key: shop.id,
      shop: shop,
      touchedItem: touchedItem,
      setTouchedItem: setTouchedItem,
      itemPathShop: [{
        name: shop.name,
        id: shop.id,
        position: index
      }],
      recordScrollPosition: recordScrollPosition
    });
  }))), isMenuOpen && isTabletView && ___EmotionJSX(SlideInMenu, {
    shops: primaryNav,
    hideMenu: hideMenu
  }));
});
MenuBar.displayName = "MenuBar";
export default MenuBar;